import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import FormError from 'components/common/FormError';
import UploadField from 'components/fields/UploadField';

import { updateBusiness } from 'redux/modules/business';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';
import imageFileTypes from 'config/imageFileTypes';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  form: {
    margin: '10px 40px',
    minHeight: 240,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function onSubmit(values, dispatch, props) {
  return new Promise((resolve, reject) => {
    dispatch(updateBusiness({
      values: {
        Image: values.Image,
        ID: values.ID,
      },
      resolve,
      reject,
      showNotification: false,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessGeneralCompanyLogoForm = ({ handleSubmit, error, classes }) => (
  <form
    className={classes.form}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classNames(classes.grid, classes.gridGutter)}
      container
      spacing={24}
    >
      <Grid item xs={12}>
        <Typography className={classes.typography} align="center">
          Add your Company Logo and it will show up on all your documentation
        </Typography>
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={10}
      >
        <Field
          id="Image"
          name="Image"
          component={UploadField}
          variant="image"
          maxSize={1000000}
          accept={imageFileTypes}
          label={(
            <Fragment>
              Drag file here <br />
              JPG, PNG or GIF <br />
              No larger than 1 MB <br />
            </Fragment>
          )}
          fullWidth
          showClearButton
        />
      </Grid>
    </Grid>
  </form>
);

BusinessGeneralCompanyLogoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessGeneralCompanyLogoForm.defaultProps = {
  error: null,
};

export default reduxForm({
  form: 'companyLogo',
  enableReinitialize: true,
  onSubmit,
})(withStyles(styles)(BusinessGeneralCompanyLogoForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessGeneralDialog/BusinessGeneralCompanyLogoForm.js